import { render, staticRenderFns } from "./basereporteconsultas.vue?vue&type=template&id=2db447c2"
import script from "./basereporteconsultas.vue?vue&type=script&lang=js"
export * from "./basereporteconsultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports